import {createContext} from "react";

export const HeadlineLevelContext = createContext<number>(0);
